@if (hasRole()) {
  <smallstack-widget-child
    [data]="data()"
    (dataChange)="dataChange.emit($event)"
    property="child"
    [context]="context()"
  ></smallstack-widget-child>
}
